
type SimpleSelectProps = {
    multiple: boolean;
    allAvailableEntries: { id: string | number, name: string }[];
    selectedIds: (string | number)[];
}

type SimpleSelectCallbacks = {
    onChangeWhileOpen: (selectedIds: string[]) => boolean;
}

export class SimpleSelect {
    
    private root: HTMLDivElement;
    private props: SimpleSelectProps;
    private callbacks: SimpleSelectCallbacks;
    
    constructor(root: HTMLDivElement, props: SimpleSelectProps, callbacks: SimpleSelectCallbacks) {
        this.root = root;
        this.props = props;
        this.callbacks = callbacks;
        
        this.init();
    }
    
    private init() {
        this.root.innerHTML = this.getHTML();
        
        this.root.querySelector(('select') as any).addEventListener('change', (e: Event) => {
            let selectedIds: string[] = [];
            let select: HTMLSelectElement = e.target as HTMLSelectElement;
            for (let i = 0; i < select.options.length; i++) {
                if (select.options[i].selected) {
                    selectedIds.push(select.options[i].value);
                }
            }
            this.callbacks.onChangeWhileOpen(selectedIds);
        });
        
    }
    
    private getHTML() {
        return `
            <div class="select">
                <select class="select__select" ${(this.props.multiple ? ' multiple="multiple" ' : '')}>
                ${this.props.allAvailableEntries.map((entry: { id: string, name: string }) => {
                    let selected_string: string = (this.props.selectedIds.includes(entry.id as never) ? 'selected="selected"' : '');
                    return `<option value="${entry.id}" ${selected_string}>${entry.name}</option>`;
                })
                .join('')}
                </select>
            </div>
            `;
    }
}